/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 218);
/******/ })
/************************************************************************/
/******/ ({

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./frontend/css/main_pre.css
var main_pre = __webpack_require__(80);

// EXTERNAL MODULE: ./frontend/css/letmoney.css
var letmoney = __webpack_require__(82);

// EXTERNAL MODULE: ./frontend/base/index.js
var base = __webpack_require__(5);

// CONCATENATED MODULE: ./frontend/forms/index.js


function csrfSafeMethod(method) {
  // these HTTP methods do not require CSRF protection
  return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
}

/* harmony default export */ var frontend_forms = (function () {
  var URL = '/brokers/reviews/add/';
  $('.submit-form').on('submit', function (e) {
    var form = this,
        $form = $(form);
    e.preventDefault();
    console.log('You submitted form!');
    $form.find('.error').remove();
    $('.alertbox').remove();
    var csrftoken = Object(base["c" /* getCookie */])('csrftoken'),
        data = $(this).serialize();
    $.ajax({
      type: 'POST',
      url: URL,
      data: data,
      headers: {
        'X-CSRFToken': csrftoken
      },
      success: function success(data) {
        window.location.href = "/brokers/review/".concat(data.id);
      },
      error: function error(resp) {
        Object(base["a" /* addAlert */])('Произошла ошибка');
        var data = resp.responseJSON;
        $.each(data, function (k) {
          var input = $form.find("[name=".concat(k, "]")),
              $input = $(input[0]),
              text = data[k].join(', ');
          $input.after("<div class=\"error\">".concat(text, "</div>"));
        });
      }
    });
  });
});
// CONCATENATED MODULE: ./frontend/index.js


 // Navigation Scripts to Show Header on Scroll-Up

jQuery(document).ready(function ($) {
  var MQL = 1023,
      SHOW_UPDOWN = 900;
  var updownButton = $('div.updown').first(); //primary navigation slide-in effect

  if ($(window).width() > MQL) {
    var headerHeight = $('.navbar-custom').height();
    $(window).on('scroll', {
      previousTop: 0
    }, function () {
      var currentTop = $(window).scrollTop(); //check if user is scrolling up

      if (currentTop < this.previousTop) {
        //if scrolling up...
        if (currentTop > 0 && $('.navbar-custom').hasClass('is-fixed')) {
          $('.navbar-custom').addClass('is-visible');
        } else {
          $('.navbar-custom').removeClass('is-visible is-fixed');
        }
      } else if (currentTop > this.previousTop) {
        //if scrolling down...
        $('.navbar-custom').removeClass('is-visible');
        if (currentTop > headerHeight && !$('.navbar-custom').hasClass('is-fixed')) $('.navbar-custom').addClass('is-fixed');
      }

      this.previousTop = currentTop;
    });
  }

  $(window).on('scroll', function () {
    var currentTop = $(window).scrollTop();

    if (currentTop > SHOW_UPDOWN) {
      updownButton.show();
    } else {
      updownButton.hide();
    }
  });
  updownButton.on('click', function () {
    window.scrollTo(0, 0);
  });
  var $similar = $('.article__similar_block');

  if ($similar.length) {
    var input = $similar.find('input[name="id"]'),
        pId = input[0].value;
    $.ajax("/api/similar/article/".concat(pId, "/")).then(function (resp) {
      if (resp && resp.length) {
        $similar.append('<h4>Читайте также:</h4>');
      } else {
        return;
      }

      resp.forEach(function (i) {
        var title = i.title,
            intro = i.intro,
            url = i.url;
        var el = "<div class=\"col-xs-12 article__similar\">\n                        <a href=\"".concat(url, "\"><strong>").concat(title, "</strong></a>\n                    </div>");
        $similar.append(el);
      });
    });
  }

  var $shareModal = $('#shareModal');
  $shareModal.on('shown.bs.modal', function () {
    $('.question__share-input').select();
  });
  frontend_forms();
});

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addSuccess; });
function getCookie(name) {
  var cookieValue = null;

  if (document.cookie && document.cookie !== '') {
    var cookies = document.cookie.split(';');

    for (var i = 0; i < cookies.length; i++) {
      var cookie = jQuery.trim(cookies[i]); // Does this cookie string begin with the name we want?

      if (cookie.substring(0, name.length + 1) === name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }

  return cookieValue;
}
function addAlert(text) {
  var dom = "\n    <div class=\"alertbox__error\">\n        <span class=\"alertbox__closebtn\">&times;</span>\n        ".concat(text, "\n    </div>"),
      $dom = $(dom);
  $dom.on('click', function () {
    $dom.remove();
  });
  $('body').append($dom);
}
function addSuccess(text) {
  var dom = "\n    <div class=\"alertbox__success\">\n        ".concat(text, "\n    </div>"),
      $dom = $(dom);
  $dom.on('click', function () {
    $dom.remove();
  });
  $('body').append($dom);
}

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })

/******/ });